import { render, staticRenderFns } from "./normalItem.vue?vue&type=template&id=0da8ca3d&scoped=true&"
import script from "./normalItem.vue?vue&type=script&lang=js&"
export * from "./normalItem.vue?vue&type=script&lang=js&"
import style0 from "./normalItem.vue?vue&type=style&index=0&id=0da8ca3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8ca3d",
  null
  
)

export default component.exports